/**
 * File functions.js.
 *
 * Contains various functions for interactions throughout the site
 */

var $ = jQuery;

var $menu;
var $pageHeader;
var popUpHeight = 400;
var popUpWidth = 580;

function setMenuStyle(resized) {
	var solidMenuHeight = 80;

	if (!$pageHeader) {
		$menu = $('#main-menu');
		$pageHeader = $('.page-header');
	}

	if (Foundation.MediaQuery.current === 'small') {
		solidMenuHeight = 50;
	}

	if ($pageHeader.length === 0 || $pageHeader[0].getBoundingClientRect().bottom <= solidMenuHeight) {
		if (!$menu.hasClass('top-bar--solid')) {
			$menu.addClass('top-bar--solid');
		}
	}
	else {
		if ($menu.hasClass('top-bar--solid')) {
			$menu.removeClass('top-bar--solid');
		}
	}
}

function togglePricingTable($table, button) {
	$(button).toggleClass('pricing-table__expand--clicked');
	$table.find('.card__body', '.card__footer').slideToggle(300);
}

function displaySharePopUp(url) {
	// Get window position relative to the screen for all browsers (screen.x for Firefox)
	var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

	// Get the window dimensions
	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	// Calculate position
	var left = ((width / 2) - (popUpWidth / 2)) + dualScreenLeft;
	var top = ((height / 2) - (popUpHeight / 2)) + dualScreenTop;

	//Display the pop up
	window.open(url, '', 'toolbar=0, status=0, width=' + popUpWidth + ', height=' + popUpHeight + ', top=' + top + ', left=' + left);
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
	Object.keys = (function() {
		'use strict';
		var hasOwnProperty = Object.prototype.hasOwnProperty,
			hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
			dontEnums = [
				'toString',
				'toLocaleString',
				'valueOf',
				'hasOwnProperty',
				'isPrototypeOf',
				'propertyIsEnumerable',
				'constructor'
			],
			dontEnumsLength = dontEnums.length;

		return function(obj) {
			if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
				throw new TypeError('Object.keys called on non-object');
			}

			var result = [], prop, i;

			for (prop in obj) {
				if (hasOwnProperty.call(obj, prop)) {
					result.push(prop);
				}
			}

			if (hasDontEnumBug) {
				for (i = 0; i < dontEnumsLength; i++) {
					if (hasOwnProperty.call(obj, dontEnums[i])) {
					result.push(dontEnums[i]);
					}
				}
			}
			
			return result;
		};
	}());
}